var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.renderAddDipsElement)?_c('a',{staticClass:"add-dips-button",on:{"click":_vm.GTMeventAddDipBasket}},[_c('span',[_vm._v(_vm._s(_vm.$t("utilityComponents.addDips.cartAddDips")))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }